export default __webpack_public_path__ + "static/media/chat9.9f27021e.jpg";